import { createRouter, createWebHashHistory } from "vue-router";
import routes from "./routes";

/**
 * @description integrates the vue router routes and
 * defines the router guard
 * @exports VueRouter
 */
const router = createRouter({
  history: createWebHashHistory(),
  // linkActiveClass: 'active',
  // linkExactActiveClass: 'active-exact',
  // scrollBehavior(to, from, savedPosition) {
  //   if (to.hash) {
  //     return {
  //       selector: to.hash
  //     };
  //   }
  //   return { left: 0, top: 0 };
  // },
  routes,
});

const isLoggedIn = () => {
  const storage = localStorage.getItem("userProfile");
  if (storage) {
    const user = JSON.parse(storage);
    if (Object.keys(user).length > 0) {
      // a user is signed in.
      return true;
    } else {
      // no user signed in
      return false;
    }
  } else return false;
};

const getUser = () => {
  const storage = localStorage.getItem("userProfile");
  if (storage) {
    return JSON.parse(storage);
  } else {
    return {};
  }
};

/**
 * This will have a more concise implentation down the road, once we
 * start using vuex.
 * https://router.vuejs.org/guide/advanced/navigation-guards.html
 */
router.beforeEach((to, from, next) => {
  // authentication route guard
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    // determine if logged in
    const isAuth = isLoggedIn();
    if (isAuth) {
      if (to.matched.some((route) => route.meta.requiresIntegrator)) {
        // if user is not an integrator and customerId === userProfile.CompanyId,
        // then user must change scope (i.e. customerId) to an integrator
        const user = getUser();
        const hasMultitennantScope = !(
          user.role.name.includes("integrator") ||
          user.role.name.includes("internationalDistributor") ||
          user.role.name.includes("oemPartner")
        );

        if (
          to.params.customerId === "undefined" ||
          (hasMultitennantScope && user.companyId === to.params.customerId) ||
          !to.params.customerId
        ) {
          alert(
            "You must set your scope to an Integrator before navigation to " +
              to.path,
          );
          next({
            path: from.path,
          });
        } else {
          // scope is already at an Integrator, proceed
          next();
        }
      } else {
        // Route does not require integrator, proceed
        next();
      }
    } else {
      // Auth required but not met, push to login
      console.log(
        "auth required, not met, push to login ",
        window.location.pathname,
        to.path,
        to.fullPath,
      );
      sessionStorage.setItem(
        "redirectPath",
        JSON.stringify({
          name: to.name,
          params: to.params,
        }),
      );
      next({
        name: "login",
        params: {
          // unique value triggers a change to show login required alert
          alert: Math.random().toString(20).substr(2, 6),
        },
      });
    }
  } else {
    // auth not required; proceed
    next();
  }
});

export default router;
